module.exports = __webpack_public_path__ + "static/media/bg1.ccb8c1e5.jpg";